/**
 * Admin Traffic Analytics Logic
 */
import Chart from 'chart.js/auto';

export function initTraffic() {
    const chartElem = document.getElementById('trafficChart');
    if (!chartElem) return;

    const ctx = chartElem.getContext('2d');
    
    // Data passed from data attributes
    const labels = chartElem.dataset.labels ? JSON.parse(chartElem.dataset.labels) : [];
    const data = chartElem.dataset.values ? JSON.parse(chartElem.dataset.values) : [];
    
    // Gradient for line chart 
    let gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, 'rgba(13, 110, 253, 0.2)'); // Primary color with opacity
    gradient.addColorStop(1, 'rgba(13, 110, 253, 0)');

    new Chart(ctx, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [{
                label: 'Page Views',
                data: data,
                backgroundColor: gradient,
                borderColor: '#0d6efd',
                borderWidth: 3,
                pointBackgroundColor: '#fff',
                pointBorderColor: '#0d6efd',
                pointBorderWidth: 2,
                pointRadius: 4,
                pointHoverRadius: 6,
                fill: true,
                tension: 0.4 
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false 
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    padding: 12,
                    displayColors: false,
                    callbacks: {
                        label: function(context) {
                            return context.raw + ' Views';
                        }
                    }
                }
            },
            scales: {
                x: {
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    grid: {
                        color: '#f8f9fa',
                        drawBorder: false,
                        borderDash: [5, 5]
                    },
                    ticks: {
                        padding: 10,
                        beginAtZero: true,
                        stepSize: 1 
                    }
                }
            },
            interaction: {
                intersect: false,
                mode: 'index',
            }
        }
    });
}
